import React, { useState, useEffect, useRef, useMemo, useImperativeHandle } from 'react';
import message from '@web-common/components/UI/Message/SiriusMessage';
import WriteContent from '@web-mail-write/WritePage';
import { TemplateAddModal } from '@web-setting/Mail/components/CustomTemplate/template_add_modal';
import { actions as mailTabActions, WriteMailTypes } from '@web-common/state/reducer/mailTabReducer';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import NeedTempDialog from '@web-mail/components/NeedTempDialog';
import styles from './TabWriteLetter.module.scss';
import { apiHolder as api, apis } from 'api';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { actions as attachmentActions } from '@web-common/state/reducer/attachmentReducer';
import useReupload from '@web-mail-write/components/SendMail/useReupload';
import useDebounceForEvent from '../../hooks/useDebounceForEvent';
import { getIn18Text } from 'api';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = api.api.getSystemApi();
const isElectron = systemApi.isElectron();
const storeApi = api.api.getDataStoreApi();
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const mailDraftApi = api.api.requireLogicalApi(apis.mailDraftApiImpl);
const TabWriteLetter = React.forwardRef((_, ref) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [execAutoSaveDraft, setExecAutoSaveDraft] = useState(false);
    const [needDraftMails, setNeedDraftMails] = useState([]);
    const [closeIds, setCloseIds] = useState([]);
    const [opening, setOpening] = useState(false);
    const openingRef = useRef(opening);
    openingRef.current = opening;
    const [closeWriteCids, setCloseWriteCids] = useState([]);
    const { currentTab } = useAppSelector(state => state.mailTabReducer);
    const { currentMail, mails } = useAppSelector(state => state.mailReducer);
    const currentMailRef = useRef(currentMail);
    currentMailRef.current = currentMail;
    const { doChangeMail } = mailActions;
    const { tabList } = useAppSelector(state => state.mailTabReducer);
    const { attachments } = useAppSelector(state => state.attachmentReducer);
    const attachmentsRef = useRef(attachments);
    attachmentsRef.current = attachments;
    const mailsRef = useRef(mails);
    mailsRef.current = mails;
    const tabListRef = useRef(tabList);
    tabListRef.current = tabList;
    const writePageRef = useRef(null);
    const [curMode, setCurMode] = useState('normal');
    const optSender = useMemo(() => { var _a; return (_a = currentMailRef.current) === null || _a === void 0 ? void 0 : _a.optSender; }, [currentMailRef.current]);
    const initSenderStr = useMemo(() => { var _a; return (_a = currentMailRef.current) === null || _a === void 0 ? void 0 : _a.initSenderStr; }, [currentMailRef.current]);
    const mailEditStatus = useMemo(() => { var _a; return (_a = currentMailRef.current) === null || _a === void 0 ? void 0 : _a.mailEditStatus; }, [currentMailRef.current]);
    const { doCloseMail, doClearMails } = mailActions;
    const { doCloseTab, doClearTabs, doCleanTabs, doChangeCurrentTab } = mailTabActions;
    const [loadEd, setLoadEd] = useState(false);
    const { doDelAttachment } = attachmentActions;
    const dispatch = useAppDispatch();
    const currentMailCid = useMemo(() => currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid, [currentMail]);
    const { clearMidFile } = useReupload();
    useEffect(() => {
        setTimeout(() => {
            setLoadEd(true);
        }, 10 * 1000);
    }, []);
    const befCloseTabs = async (closeWriteCids) => {
        const needDraftMails = [];
        const closeWriteMails = mails.filter(item => closeWriteCids.includes(item.cid));
        const judgeMailP = (mail) => {
            return new Promise(async (resolve) => {
                const res = await mailApi.doNeedSaveTemp(mail);
                resolve(res);
            });
        };
        return new Promise(resolve => {
            Promise.allSettled(closeWriteMails.map(judgeMailP)).then(judgeArr => {
                judgeArr.forEach((item, index) => {
                    const { status, value } = item;
                    if (status === 'fulfilled') {
                        if (value) {
                            needDraftMails.push(closeWriteMails[index]);
                        }
                    }
                });
                if (needDraftMails.length > 0) {
                    resolve({
                        closeable: false,
                        needDraftMails,
                    });
                }
                resolve({ closeable: true });
            });
        });
    };
    const afterApply = (needDraftMails, closeIds) => {
        setTimeout(() => {
            setNeedDraftMails([...needDraftMails]);
            if (closeIds.length === 1) {
                if (closeIds[0] !== String(currentTab.id)) {
                    dispatch(doChangeCurrentTab(closeIds[0]));
                }
            }
            if (closeIds.length > 1) {
                dispatch(doChangeCurrentTab(String(needDraftMails[0].cid)));
            }
            setIsModalVisible(true);
        });
    };
    const applyCloseMails = async (closeWriteCids) => {
        try {
            const closeWriteMails = mailsRef.current.filter(item => closeWriteCids.includes(item.cid));
            const hasDynMail = closeWriteMails.some(m => { var _a; return ((_a = m === null || m === void 0 ? void 0 : m.status) === null || _a === void 0 ? void 0 : _a.useVariable) || (m === null || m === void 0 ? void 0 : m.isDyncGroupSend); });
            if (hasDynMail) {
                return await new Promise(resolve => {
                    SiriusModal.confirm({
                        title: '您正在写信中，是否离开写信页面？',
                        okText: '离开',
                        cancelText: '取消',
                        onOk: () => {
                            setExecAutoSaveDraft(false);
                            dispatch(doClearMails(closeWriteCids));
                            resolve({ res: true });
                        },
                        onCancel: () => {
                            resolve({ res: false });
                        },
                    });
                });
            }
            const judgeRes = await befCloseTabs(closeWriteCids);
            const { needDraftMails, closeable } = judgeRes;
            if (closeable) {
                setExecAutoSaveDraft(false);
                dispatch(doClearMails(closeWriteCids));
                return { res: true };
            }
            if (!needDraftMails)
                return { res: true };
            return { res: false, needDraftMails };
        }
        catch (error) {
            console.error(getIn18Text('SHENQINGGUANBIBIAO'), error);
            return { res: false };
        }
    };
    const doCancelCompose = (mid) => {
        mailApi.doCancelCompose(mid, false, initSenderStr);
        clearMidFile(mid);
    };
    const doubleCkTabAction = useDebounceForEvent(() => {
        setOpening(true);
        if (attachmentsRef.current.some(attachment => attachment.mailId === currentMailRef.current.cid && attachment.status && attachment.status !== 'success' && attachment.type !== 'download')) {
            message.warn({ content: getIn18Text('FUJIANSHANGCHUANZHONG') });
            setOpening(false);
            return;
        }
        if (mailEditStatus && ['saving', 'delivering', 'reGenerating', 'reUploading'].includes(mailEditStatus)) {
            message.warn({ content: getIn18Text('QINGSHAOHOUZHONGSHI') });
            setOpening(false);
            return;
        }
        const curAttachments = attachmentsRef.current.filter(item => item.mailId == currentMailRef.current.cid);
        const objAttachments = curAttachments.map(item => {
            const tmp = {};
            for (let i in item) {
                if (typeof item[i] !== 'function' && i !== 'arrayBuffer') {
                    tmp[i] = item[i];
                }
            }
            return tmp;
        });
        objAttachments && storeApi.putSync('curAttachments', JSON.stringify(objAttachments));
        const current = Object.assign(Object.assign(Object.assign({}, currentMailRef.current), { entry: Object.assign(Object.assign({}, currentMailRef.current.entry), { attachments: objAttachments, attachmentCount: objAttachments.length, withoutPlaceholder: true }) }), { _account: initSenderStr });
        mailApi
            .doSaveTemp({ content: current, saveDraft: true, auto: false })
            .then(res => {
            setOpening(false);
            const { cid, _id, draftId } = res;
            if (cid) {
                const draftedMail = Object.assign(Object.assign({}, currentMail), { _id,
                    draftId });
                dispatch(doChangeMail(draftedMail));
            }
            const params = {
                id: draftId,
                mailType: 'draft',
                writeType: 'editDraft',
                withoutPlaceholder: true,
                writeWay: 'newWin',
                optSenderStr: (optSender === null || optSender === void 0 ? void 0 : optSender.id) || '',
                _account: initSenderStr,
            };
            mailApi.callWriteLetterFunc(params);
            if (currentMailCid) {
                setIsModalVisible(false);
                setExecAutoSaveDraft(false);
                let curRmCid = currentMailRef.current.cid;
                curRmCid && dispatch(doClearMails([curRmCid]));
                dispatch(doCloseTab(String(curRmCid)));
            }
        })
            .catch(err => {
            console.log(getIn18Text('DAKAIXINCHUANGKOU'), err);
            setOpening(false);
            message.fail({
                content: `打开新窗口失败${(err === null || err === void 0 ? void 0 : err.title) ? `:${err.title}` : ''}`,
            });
        });
    }, 400);
    const doubleCkTabFun = () => {
        if (!isElectron)
            return;
        if (openingRef.current)
            return;
        doubleCkTabAction();
    };
    const dialogConfirmNotSave = () => {
        setIsModalVisible(false);
        setExecAutoSaveDraft(false);
        dispatch(doClearMails(closeWriteCids));
        mailDraftApi.deleteDraftMailByCid(closeWriteCids);
        if (closeIds.length === 1) {
            dispatch(doCloseTab(closeIds[0]));
        }
        else {
            dispatch(doCleanTabs());
        }
        closeWriteCids.forEach(item => doCancelCompose(item));
        dispatch(doDelAttachment({ cid: closeWriteCids }));
    };
    const dialogConfirmSave = (failCids) => {
        setIsModalVisible(false);
        setExecAutoSaveDraft(false);
        if (failCids) {
            dispatch(doClearMails(closeWriteCids.filter(item => !failCids.includes(item))));
            dispatch(doClearTabs(closeIds === null || closeIds === void 0 ? void 0 : closeIds.filter(item => !failCids.map(String).includes(item))));
            dispatch(doChangeCurrentTab(String(failCids[0])));
            closeWriteCids.forEach(item => {
                if (!failCids.includes(item))
                    doCancelCompose(item);
            });
            dispatch(doDelAttachment({
                cid: closeWriteCids.filter(item => !failCids.includes(item)),
            }));
            return;
        }
        dispatch(doClearMails(closeWriteCids));
        if (closeIds.length === 1) {
            dispatch(doCloseTab(closeIds[0]));
        }
        else {
            dispatch(doCleanTabs());
        }
        closeWriteCids.forEach(item => doCancelCompose(item));
        dispatch(doDelAttachment({ cid: closeWriteCids }));
    };
    const closeTab = async (closeIds) => {
        setCloseIds(closeIds);
        const closeWriteCids = [];
        mailsRef.current.forEach(mail => {
            if (mail.cid && closeIds.includes(String(mail.cid))) {
                closeWriteCids.push(mail.cid);
            }
        });
        if (closeWriteCids.length > 0) {
            setCloseWriteCids(closeWriteCids);
            const res = await applyCloseMails(closeWriteCids);
            if (res.res) {
                mailDraftApi.deleteDraftMailByCid(closeWriteCids);
                dispatch(doDelAttachment({ cid: closeWriteCids }));
                closeWriteCids.forEach(item => doCancelCompose(item));
            }
            else if (res.needDraftMails) {
                afterApply(res.needDraftMails, closeIds);
            }
            return res.res;
        }
        return true;
    };
    const saveDraft = (id) => {
        try {
            const target = mailsRef.current.find(item => String(item.cid) === id);
            if (target)
                mailApi.doSaveTemp({ content: target, saveDraft: true });
        }
        catch (error) {
            console.log(getIn18Text('BAOCUNSHIBAI'), error);
        }
    };
    const innerCloseTab = async (id) => {
        const res = await closeTab([id]);
        if (res) {
            dispatch(mailTabActions.doCloseTab(id));
        }
    };
    useImperativeHandle(ref, () => {
        return {
            closeTab,
            doubleCkTab: doubleCkTabFun,
            saveDraft,
        };
    });
    useEffect(() => {
        const { type } = currentTab;
        if (WriteMailTypes.includes(type)) {
            setExecAutoSaveDraft(true);
        }
        else {
            setExecAutoSaveDraft(false);
        }
    }, [currentTab]);
    useEffect(() => {
        if (!window || (window && window.electronLib))
            return;
        window.onbeforeunload = () => {
            const allMailCids = [];
            tabListRef.current.forEach((tab) => {
                const { type, id } = tab;
                if (WriteMailTypes.includes(type)) {
                    allMailCids.push(Number(id));
                }
            });
            if (allMailCids.length > 0) {
                return getIn18Text('NINQUEDINGYAOLI');
            }
        };
        return () => (window.onbeforeunload = () => { });
    }, []);
    if ((!currentMail || JSON.stringify(currentMail) === '{}') && !loadEd) {
        return null;
    }
    return (React.createElement("div", { className: styles.tabWriteLetter },
        React.createElement(WriteContent, { ref: writePageRef, style: { minWidth: '805px' }, execAutoSaveDraft: execAutoSaveDraft, innerCloseTab: innerCloseTab, curMode: curMode, setCurMode: setCurMode, cond: "mailBox" }),
        React.createElement(TemplateAddModal, { maskStyle: curMode === 'max' ? { left: 0 } : {} }),
        React.createElement(NeedTempDialog, { maskStyle: curMode === 'max' ? { left: 0 } : {}, isModalVisible: isModalVisible, needSaveMails: needDraftMails, setIsModalVisible: val => setIsModalVisible(val), onNotSave: () => dialogConfirmNotSave(), onSave: () => dialogConfirmSave(), closeWriteNum: closeWriteCids.length })));
});
export default TabWriteLetter;
